import clsx from 'clsx'
import React from 'react'

import {layoutClasses} from './classes'
import {LayoutStyleProps} from './types'

const Layout: React.FC<React.PropsWithChildren<LayoutStyleProps>> = ({
  className,
  layout = 'default',
  background = 'main',
  style,
  children,
}) => {
  return (
    <div
      className={clsx(
        layoutClasses.layout,
        layout !== 'noSidebar' && layoutClasses.layoutSidebar,
        background === 'minor' && layoutClasses.minor,
        className,
      )}
      style={style}
    >
      {children}
    </div>
  )
}

export default Layout
